import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/warranty.actions';
import { Col, Row, Form, Modal, Select, Input, Upload, Icon, DatePicker } from 'antd';
import { dspxGetChildrens } from '../helpers/dspx-utils'
import PhoneNumberInput from '../components/phone-input';
import IconCheckBox from '../components/icon-checkbox';
import { RubleIcon } from '../resource/icons';
import moment from 'moment';

const { TextArea } = Input;

const WarrantyForm = Form.create()(
	class extends React.Component {

		constructor(props) {
			super(props)

			this.state = {
				fileList: [],
				docTitle: undefined,
			}
		}

		handleDocTypeCHange = (val) => {
			if(this.props.form.getFieldValue('name')) return

			this.props.form.setFieldsValue({['name']: this.props.fprops.fileTypesRef.find(o=>o.id==val).name});
//			+ ' от ' + this.props.form.getFieldValue('docDate').format('DD.MM.YYYY')});
		}

		/*handleDocDateCHange = (val) => {
			if(this.props.form.getFieldValue('name')) return

			this.props.form.setFieldsValue({['name']: this.props.form.getFieldValue('name') 
				+ ' от ' + this.props.form.getFieldValue('docDate').format('DD.MM.YYYY')});
		}*/

		handleServiceChange = (value) => {
			this.props.form.resetFields(['typeId'])
			this.props.dispatch(actions.applyService(value));
		}

		handleAddrStreetChange = (value) => {
			this.props.form.resetFields(['addressId'])
			this.props.dispatch(actions.applyAddrStreet(value));
		}

		handleSubserviceChange = (value) => {
			this.props.dispatch(actions.applySubservice(value));
		}

		handleAddrBuildingChange = (value) => {
			this.props.form.resetFields(['addressId'])
			this.props.dispatch(actions.applyAddrBuilding(value));
		}

		handleAddrFlatChange = (value) => {
			this.props.dispatch(actions.setAddrFlatValue(value));
		}

		render() {
			const { visible, onCancel, onCreate, form, fprops } = this.props;
			const { getFieldDecorator } = form;

			return (
				<Modal
					width={520}
					visible={visible}
					title={"Перевести в " + (fprops.newWarranty === '1' ? "гарантийные" : "обычные")}
					okText={"Перевести в " + (fprops.newWarranty === '1' ? "гарантийные" : "обычные")}
					onCancel={onCancel}
					onOk={onCreate} >
					<Form layout="vertical">
						{getFieldDecorator('request', { initialValue: fprops.request })(
							<Input type='hidden' />)}
						{getFieldDecorator('newState', { initialValue: fprops.newWarranty })(
							<Input type='hidden' />)}

						<Row gutter={16}>
							<Col span={24}>
								<Form.Item label="Документ">
									{getFieldDecorator('file', {
										rules: [{ required: false, message: 'Пожалуйста прикрепите документ' }]
									})(
										<Upload.Dragger
											name='file'
											fileList={this.state.fileList}
											multiple={false}
											beforeUpload={(file) => {
												this.setState(({ fileList }) => ({
													//fileList: [...fileList, file]
													fileList: [file]
												}));
												return false;
											}}
											onRemove={(file) => {
												this.setState(({ fileList }) => {
													const index = fileList.indexOf(file);
													const newFileList = fileList.slice();
													newFileList.splice(index, 1);
													return {
														fileList: newFileList,
													};
												});
											}}>
											<Icon type="file-add" theme="outlined" /> перетащите файл сюда, или нажмите, чтобы выбрать
									</Upload.Dragger>)}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col span={8}>
								<Form.Item label="Дата" >
									{getFieldDecorator('docDate', {
										initialValue: moment(),
										rules: [{ required: true, message: 'Пожалуйста укажите дату документа' }]
									})(
										<DatePicker
											allowClear={false}
											format='DD.MM.YYYY'
											//onChange={this.handleDocDateCHange}
										/>

									)}
								</Form.Item>
							</Col>
							<Col span={16}>
								<Form.Item label="Тип документа">
									{getFieldDecorator('type', {
										rules: [{
											required: false,
											message: 'Пожалуйста, выберите тип документа'
										}]
									})(
										<Select
											showSearch
											placeholder="тип документа"
											notFoundContent='нет данных'
											optionFilterProp="searchtext" 
											onChange={this.handleDocTypeCHange}
											>
												{dspxGetChildrens(fprops.fileTypesRef)}
										</Select>)}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col span={24}>
								<Form.Item label="Наименование">
									{getFieldDecorator('name', {
										initialValue: this.state.docTitle,
										rules: [{ required: false, message: 'Пожалуйста введите наименование документа' }]
									})(
										<Input 											
											placeholder='Наименование документа'/>)}
								</Form.Item>
							</Col>
						</Row>
						{/*<Row gutter={16}>
							<Col span={24}>
									{getFieldDecorator('type', { initialValue: '11' })( 
									<Input type='hidden' />)}
							</Col>
									</Row>*/}
					</Form>
				</Modal>
			);
		}
	});

class WarrantyContainer extends Component {

	componentDidMount() {
		this.props.dispatch(actions.fetchFileTypesList());
	}

	handleCancel = () => {
		this.formRef.props.form.resetFields();
		this.formRef.state.fileList = []
		this.props.dispatch(actions.closeWarrantyModal());
	}

	handleCreate = () => {
		const form = this.formRef.props.form;

		form.validateFields((err, values) => {

			const attachments = this.formRef.state.fileList;

			//if (err || attachments.length < 1) return
			if (err) return

			form.resetFields()
			this.formRef.state.fileList = []
			this.props.dispatch(actions.postWarrantyState(values, attachments))
			this.props.dispatch(actions.closeWarrantyModal())
		});
	}

	saveFormRef = (formRef) => {
		this.formRef = formRef;
	}

	render() {
		return (
			<WarrantyForm
				wrappedComponentRef={this.saveFormRef}
				visible={this.props.warrantyModalVisible}
				dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
				fprops={this.props}
			/>
		)
	}
}

function mapStateToProps(state) {
	const { warrantyStore } = state;
	return warrantyStore;
}

export default connect(mapStateToProps)(WarrantyContainer);